import gql from 'graphql-tag';

export const allListsGql = gql`
  query ($instId: String!, $accountId: String!, $sort: String!, $size: Int!) {
    paginatedList(
      instId: $instId
      accountId: $accountId
      sort: $sort
      size: $size
      myListsOnly: false
    ) {
      page
      totalPages
      totalRecords
      recordsPerPage
      lists: list {
        value: id
        label: name
      }
    }
  }
`;
// FindListsByIds_GQL
export const findListsByIdsGql = gql`
  query (
    $instId: String!
    $accountId: String!
    $size: Int!
    $listIds: [String]
  ) {
    paginatedList(
      instId: $instId
      accountId: $accountId
      size: $size
      listIds: $listIds
    ) {
      list {
        value: id
        label: name
      }
    }
  }
`;
